// Redux Saga
import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { devicesApi } from 'services/apiDigitalTicket/devices';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as DevicesActions from './actions';
import { DevicesTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof DevicesActions.listDevicesRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando...' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(devicesApi.list, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        DevicesActions.listDevicesSuccess({
          devicesList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('devices - list - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(DevicesActions.listDevicesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* get({
  payload,
}: ReturnType<typeof DevicesActions.listDeviceRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando...' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(devicesApi.list, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        DevicesActions.listDeviceSuccess({
          deviceData: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('device - get - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(DevicesActions.listDeviceFailure());
    yield put(DialogsActions.setClose());
  }
}

function* deviceStatus({
  payload,
}: ReturnType<typeof DevicesActions.updateStatusRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Atualizando status...' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(devicesApi.updateStatus, {
      params: { transportOperatorId: transportOperator.id, ...payload },
      id: payload.id,
    });

    const userId = yield select(
      (state: ApplicationState) => state.users.appUserData.id,
    );

    if (response.status === 200) {
      yield put(DevicesActions.updateStatusSuccess());

      yield put(DialogsActions.setClose());

      yield put(
        DevicesActions.listDevicesRequest({
          userId,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('devices - update status - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(DevicesActions.updateStatusFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const devicesSagas = [
  takeLatest(DevicesTypes.LIST_DEVICE_REQUEST, get),
  takeLatest(DevicesTypes.LIST_DEVICES_REQUEST, list),
  takeLatest(DevicesTypes.UPDATE_STATUS_REQUEST, deviceStatus),
];
